import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPossibleProducts as GetPossibleProductsQuery,
    GetPossibleProductsVariables,
} from 'nutshell-graphql-types';

import GET_POSSIBLE_PRODUCTS from '../queries/get-possible-products.graphql';

export const useGetPossibleProducts = (quoteId: string, isTemplate: boolean) => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetPossibleProductsQuery, GetPossibleProductsVariables>(GET_POSSIBLE_PRODUCTS, {
        variables: {quoteId: quoteId},
        fetchPolicy: 'cache-and-network',
        skip: isTemplate,
    });

    const {quotePossibleProducts} = makeDataDangerous(data);

    return {
        quotePossibleProducts,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
